import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Drawer } from '@mui/material';
import { AddButton, CloseButton, Loader, MinLoader, SelectTypeAutocomplete } from 'components';
import { RenderWidgetImage, checkFilter, WidgetCategoriesDashboard } from '../constants';
import { FindLoad } from 'utils';
import { Svg } from 'assets';
import { dashboardActions } from 'store';
import { DefaultDates } from '../../../report/analyticFragment/fragments/constants';

const ACTION_TYPE = 'GET_DASHBOARD_USER_FILTERED_KPIS';
const ADD_ACTION_TYPE = 'ADD_DASHBOARD_USER_KPI';

export const AddWidgetDashboard = () => {
    const [openDrawer, setOpenDrawer] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const [inputs, setInputs] = useState({});
    const { listKpis } = useSelector((state) => ({
        listKpis: state.dashboard.listKpis,
    }));
    const navigate = useNavigate();
    const location = useLocation();
    const info = location?.state;
    const dispatch = useDispatch();
    const loader = FindLoad(ACTION_TYPE);
    const addLoad = FindLoad(ADD_ACTION_TYPE);
    const { allDates } = DefaultDates(info);
    const sortedKpis = [...(listKpis || [])].sort((a, b) => (a?.added === b?.added ? 0 : a?.added ? 1 : -1));

    useEffect(() => {
        dispatch(dashboardActions.getUserFilteredKpis());
    }, [dispatch]);

    useEffect(() => {
        if (openDrawer) {
            setInputs({});
        }
    }, [openDrawer]);
    const closeDrawer = () => {
        setOpenDrawer(false);
    };
    const addToUser = (id) => {
        setSelectedId(id);
        dispatch(dashboardActions.addUserKpi(id, allDates));
    };

    const handleChange = (e) => {
        const params = {
            ...inputs,
        };
        if (e.target.value === 'All' || !e.target.value) {
            delete params[e.target.name];
        } else {
            params[e.target.name] = e.target.value;
        }
        setInputs(params);
    };

    return (
        <div>
            <AddButton text={'Add Widget'} handleClick={() => setOpenDrawer(true)} />

            <Drawer sx={{ zIndex: 1300 }} className={'add-widget-modal-dashboard'} anchor={'right'} open={openDrawer} onClose={closeDrawer}>
                <div className="add-widget-inner">
                    <div className="add-widget-header">
                        <div className="add-widget-header-titles">
                            <p className="add-widget-title">Add widget</p>
                            <p className="add-widget-subtitle">
                                {listKpis?.filter((k) => k?.added)?.length || 0} of {listKpis?.length || 0} on your dashboard
                            </p>
                        </div>
                        <CloseButton handleCLic={closeDrawer} />
                    </div>

                    <div className="add-widget-filter">
                        <SelectTypeAutocomplete
                            placeholder={inputs?.category ? '' : 'All'}
                            defaultValue={inputs?.category}
                            name={'category'}
                            handleSelect={handleChange}
                            list={WidgetCategoriesDashboard}
                            renderValue={(i) => i?.name}
                            uiType={'tableFilter'}
                            noError={true}
                            popperZIndex={1302}
                        />
                    </div>

                    <div className="add-widget-body">
                        {loader?.length ? (
                            <Loader />
                        ) : (
                            sortedKpis?.map(
                                (i, j) =>
                                    checkFilter(inputs, i) && (
                                        <div className="widget-list-card-dashboard-box" key={j}>
                                            <div className="widget-list-card-icon-name-box">
                                                {RenderWidgetImage(i?.id)}
                                                <div className="widget-list-card-text">
                                                    <p className="widget-list-card-name">{i?.name}</p>
                                                    <p className="widget-list-card-desc">{i?.description}</p>
                                                </div>
                                            </div>

                                            {i?.added ? (
                                                <button type="button" className="added-widget-btn">
                                                    <Svg.CheckCircleSvg />
                                                    <span>Added</span>
                                                </button>
                                            ) : (
                                                <button type="button" className="add-widget-btn" onClick={() => addToUser(i?.id)}>
                                                    {selectedId === i?.id && addLoad?.length ? (
                                                        <MinLoader width={16} height={16} position={'relative'} color={'#0B5DCF'} margin={'0'} />
                                                    ) : (
                                                        <Svg.AddCircleSvg />
                                                    )}
                                                    <span>Add</span>
                                                </button>
                                            )}
                                        </div>
                                    )
                            )
                        )}
                    </div>
                </div>
            </Drawer>
        </div>
    );
};
